import { render, staticRenderFns } from "./ProductBrandsList.vue?vue&type=template&id=7de23d3a&scoped=true&"
import script from "./ProductBrandsList.vue?vue&type=script&lang=js&"
export * from "./ProductBrandsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de23d3a",
  null
  
)

export default component.exports